module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n  <app-form></app-form>\n"


//////////////////
// WEBPACK FOOTER
// /Users/luciana/Projetos/example-mask/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main